import { SpokePageSpinner } from '@doltech/core/lib/auth/SpokePageSpinner';
import { DynamicPageProps } from '@doltech/routeDefinition';
import cl from 'classnames';
import dynamic from 'next/dynamic';
import * as React from 'react';
import styled from 'styled-components';

import { LandingLayout, LandingLayoutContent } from '../LandingLayout';
import { LandingSideBar } from '../LandingSidebar/LandingSidebar';
import { LandingHeaderFullWidth } from '../PremadeHeader/LandingHeaderFullWidth';
import { LandingPromotionFreeTestBanner } from '../../../../shared/templates/LandingBlog/PromotionTypeForLandingPage/LandingPromotionFreeTestBanner';
import { JuniorPromotionBanner } from '../ui/JuniorPromotionBanner/JuniorPromotionBanner';

const SharedFooter = dynamic<any>(() =>
  import('../Footer/SharedFooter').then((mod) => mod.SharedFooter)
);
//

const Main = styled.div`
  .breadcrumb-item {
    > * {
      text-transform: none;
    }
  }
`;
export interface LandingBlogSampleLayoutContentProps extends DynamicPageProps {
  children?: React.ReactNode;
  pageProps: any;
  defaultSidebarOpen?: boolean;
  withHeader?: boolean;
  showPromotion?: boolean;
  withFooter?: boolean;
  logoColored?: boolean;
  loading?: boolean;
}

const LandingBlogDetailSampleLayout = ({
  children,
  defaultSidebarOpen = false,
  withHeader = true,
  showPromotion = false,
  withFooter = true,
  logoColored = true,
  loading = false,
  pageProps,
  ...rest
}: LandingBlogSampleLayoutContentProps) => {
  return (
    <Main className={cl({ 'no-header': !withHeader, 'no-footer': !withFooter })}>
      <JuniorPromotionBanner />
      <LandingLayout defaultSidebarOpen={defaultSidebarOpen} {...rest}>
        {withHeader && (
          <LandingHeaderFullWidth logoColored={logoColored} showBanner={showPromotion} />
        )}

        {loading && <SpokePageSpinner />}
        {!loading && (
          <LandingLayoutContent>
            {withHeader && (
              <LandingLayoutContent.LeftOverlaySidebar displayAsSideBar>
                <LandingSideBar disableHeadTag />
              </LandingLayoutContent.LeftOverlaySidebar>
            )}
            <LandingLayoutContent.SectionMiddle>{children}</LandingLayoutContent.SectionMiddle>
          </LandingLayoutContent>
        )}
      </LandingLayout>
      <LandingPromotionFreeTestBanner />
      {withFooter && <SharedFooter />}
    </Main>
  );
};

export default LandingBlogDetailSampleLayout;
